import { Component, OnInit } from '@angular/core';
import {PageService} from "../../services/page.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private pService:PageService,private route: ActivatedRoute,
      private router: Router) { }


  supportMenu:any;
  supportMenuArray = [];

  mediaMenu:any;
  mediaMenuArray =[];

  otherMenu:any;
  otherMenuArray = [];

  nodisplay:boolean = false;

  ngOnInit() {
  	this.pService.getSupportMenu().subscribe((result:any)=>{
  		this.supportMenu = result;
  		for(let key in this.supportMenu){
  			let str = {'key':key,'value':this.supportMenu[key]};
  			this.supportMenuArray.push(str);
  		}
  	})

  	this.pService.getMediaMenu().subscribe((result:any)=>{
  		this.mediaMenu = result;
  		for(let key in this.mediaMenu){
  			let str = {'key':key,'value':this.mediaMenu[key]};
  			this.mediaMenuArray.push(str);
  		}
  	})

    this.pService.getOtherMenu().subscribe((result:any)=>{
      this.otherMenu = result;
      for(let key in this.otherMenu){
        let str = {'key':key,'value':this.otherMenu[key]};
        this.otherMenuArray.push(str);
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts